import React from 'react';
import colors from '../../../../helpers/colors';
import Alert from './Alert';
import ExplanatoryText from './ExplanatoryText';
import Label from './Label';
import Legend from './Legend';
import Tooltip, { TooltipProps } from './Tooltip';
import { InfoWrapper } from './styles';

export type FieldInfoProps = {
  alertBody?: string;
  children?: React.ReactNode;
};

const FieldInfo: React.FC<FieldInfoProps> = ({ alertBody, children }) => (
  <InfoWrapper>
    <div>{children}</div>
    {alertBody && (
      <Alert
        html={alertBody}
        backgroundColor={colors.notificationWarningLight}
        linkBorderColor={colors.core02}
      />
    )}
  </InfoWrapper>
);

export default FieldInfo;
export { Alert, ExplanatoryText, Label, Legend, Tooltip };
export type { TooltipProps };
